import {Module} from '@mamdev/cad.static-next-lib';
import Tracking2 from '../../ts/services/tracking2';

export default class TopNav extends Module {
  private navBar: HTMLElement | null;

  static attachTo(root: HTMLElement): TopNav {
    return new TopNav(root);
  }

  constructor(root: HTMLElement) {
    super(root);
    this.name_ = 'topnav';
  }

  start() {
    this.navBar = this.root_.querySelector('nav > ul');

    if (this.navBar) {
      this.navBar.addEventListener('click', ev => {
        this.trackNavClick(ev.target as HTMLAnchorElement);
      });
    }
  }

  trackNavClick(anchor?: HTMLAnchorElement) {
    if (anchor) {
      this.sendToTracking2(anchor);
      this.sendToBrain(anchor);
    }
  }

  sendToBrain(anchor: HTMLAnchorElement) {
    const brainZone = anchor.getAttribute('data-brain-zone');
    if (brainZone) {
      const bzArray = brainZone.split('.');
      const trackData = {
        'click1': bzArray[1],
        'click2': bzArray[2],
        'click3': bzArray[3],
        'click4': bzArray[4],
        'clickname': 'undefined'
      };
      this.publish('topnav', trackData);
    }
  }

  sendToTracking2(anchor: HTMLAnchorElement) {
    const componentPath = anchor.getAttribute('data-component-path');
    const anchorText = (anchor.textContent ?? '').trim();
    const labelText = anchorText.includes(' ') ? anchorText.split(' ')[0] : anchorText;

    if (componentPath) {
      Tracking2.callTealiumLink({
        businessEventType: 'userAction',
        componentPath: componentPath,
        componentLabel: labelText,
        elementTagName: 'a',
        eventType: 'mousedown'
      });
    }
  }
}
